import { useEffect, useState } from 'react';
import { Snackbar } from '@mui/material';
import { initVersionChecker } from '../services/versionChecker';

export default function VersionUpdateNotifier() {
    const [updating, setUpdating] = useState(false);
    const [versionInfo, setVersionInfo] = useState(null);

    useEffect(() => {
        // Initialize background version checking
        const cleanup = initVersionChecker();

        const handleUpdate = (event) => {
            setVersionInfo(event.detail);
            setUpdating(true);
        };

        window.addEventListener('appVersionUpdate', handleUpdate);

        return () => {
            if (cleanup) cleanup();
            window.removeEventListener('appVersionUpdate', handleUpdate);
        };
    }, []);

    if (!updating) return null;

    return (
        <Snackbar
            open={updating}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            message={
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontFamily: 'Poppins-Regular', fontSize: 13.5 }}>
                    <div style={{
                        width: 10,
                        height: 10,
                        borderRadius: '50%',
                        backgroundColor: '#4ade80',
                        boxShadow: '0 0 8px #4ade80',
                        animation: 'pulse 1.5s infinite'
                    }} />
                    <span>New version ({versionInfo?.version || 'latest'}) detected! Clearing cache & updating...</span>
                </div>
            }
            ContentProps={{
                style: {
                    backgroundColor: '#1e293b',
                    color: '#ffffff',
                    borderRadius: 12,
                    boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
                    padding: '8px 20px'
                }
            }}
        />
    );
}
